//
//
//
//
//

import videojs from 'video.js';
import video_zhCN from 'video.js/dist/lang/zh-CN.json';
export default {
  name: 'VideoPlayer',
  props: {
    videoSrc: {
      type: String,
      default: null,
    },
    videoImg: {
      type: String,
      default: null,
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      player: null,
      videoOptions: {
        width: '440',
        height: '600',
        autoplay: true,
        controls: true,
        playbackRates: [0.5, 1, 1.5, 2],
        language: 'zh-CN',
      },
    };
  },
  mounted() {
    const obj = Object.assign(this.videoOptions, this.options);
    Object.assign(obj, {
      sources: [
        {
          type: 'video/mp4',
          src: this.videoSrc,
          poster: this.videoImg,
        },
      ],
    });
    videojs.addLanguage('zh-CN', video_zhCN);
    this.player = videojs(this.$refs.videoPlayer, obj, () => {
      // eslint-disable-next-line no-console
      console.log('onPlayerReady', this);
    });
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
